require("reading/shelves/my_work.scss");

var CurrentUser = require("lib/account/CurrentUser");
import { Link } from "react-router-dom";
import { providePopulateData } from "components/utility/hoc/PopulateData";

import { connect } from "react-redux";
import { response } from "../../../lib/selectors/WritingSelectors";

var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var ExpandedWorkDetails = require('components/reading/shelves/ExpandedWorkDetails.js')

var ArbitrarySubjects = require("lib/data/ArbitrarySubjects");
var Features = require('lib/account/Features');

var Glyphicon = require("components/utility/icons/Glyphicon");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var DataActions = require("lib/actions/DataActions");
var DataSelectors = require("lib/selectors/DataSelectors");


var MyShelfRouting = require("lib/routing/MyShelfRouting");

@connect(
  (state, props) => {
    var userID = CurrentUser.get().id;

    var draftQuizzes = WritingSelectors.quizzes({
      state, conditions: { userID }, filters: { draft: true }
    });
    var draftAnswers = WritingSelectors.nonQuizAnswers({
      state, conditions: { userID }, filters: { draft: true }
    });
    var draftReviews = WritingSelectors.reviews({
      state, conditions: { userID }, filters: { draft: true }
    });
    var draftResponses = WritingSelectors.responses({
      state, conditions: { userID }, filters: { draft: true }
    });
    var draftQuestionBuilders = WritingSelectors.metaCognitiveAnswers({
      state, conditions: { userID }, filters: { draft: true }
    });

    var draftCount = draftQuizzes.length + draftAnswers.length +
      draftReviews.length + draftResponses.length + draftQuestionBuilders.length;;

    var quizzes = WritingSelectors.quizzes({ state, conditions: { userID } })
    var answers = WritingSelectors.nonQuizAnswers({ state, filters: { userID } })
    var reviews = WritingSelectors.reviews({ state, conditions: { userID } })
    var activities = WritingSelectors.activities({ state, conditions: { userID } })
    var tasks = WritingSelectors.tasks({ state, conditions: { userID } })
    var questionBuilders = WritingSelectors.metaCognitiveAnswers({ state, conditions: { userID } })

    return { userID, quizzes, answers, reviews, activities, tasks, questionBuilders, draftCount }
  },
  (dispatch, props) => ({
    populateData: () => {
      // TODO: trello card made to convert this to BE pagination
      var conditions = { allowDraft: true, perPage: 1000};
      // get quizzes
      var filters = {
        user_id: CurrentUser.get().id,
        draft: true,
      }
      var embeds = ["quiz.gold_records", "quiz.answer_ids"]

      var quizzes = dispatch(WritingActions.fetchQuizzes({
        filters, embeds,
        conditions: { noPagination: true },
        fetchDetails: false,
        cache: true
      }));

      // get responses
      filters = {
        user_id: CurrentUser.get().id,
        draft: true
      }
      var responses = dispatch(WritingActions.fetchResponses({
        filters,
        embeds: ["response.activity", "activity.format_summary"],
        draft: true,
        cache: true
      }))

      // get tasks
      filters = {
        user_id: CurrentUser.get().id,
        draft: true
      }
      embeds = ["activity.format_summary", 'task.task_items']

      var tasks = dispatch(WritingActions.fetchTasks({
        filters, embeds,
        fetchDetails: true,
        conditions,
        cache: true
      }));
      // get answers
      filters = {
        user_id: CurrentUser.get().id,
        draft: true
      }
      var embeds = [
        "answer.question", "question.answer_options",
        "answer.evaluation", "evaluation.score_details",
        "answer.meta_data", "answer.gold_records"
      ]
      var answers = dispatch(WritingActions.fetchAnswers({
        filters, embeds,
        fetchDetails: true,
        conditions,
        page: 1,
        cache: true
      }));

      return Promise.all([quizzes, responses, tasks, answers]);
    },
    fetchSingleBookActivity: textID => {
      var userID = CurrentUser.get().id;
      var embeds = [
       "book.ratings", "book.quizzes", "quiz.gold_records",
        "quiz.evaluation", "quiz.warmup_questions", "evaluation.score_details"];

      var conditions = { allowDraft: true };
      var query = { user_id: userID };


      return dispatch(ReadingActions.fetchSingleBookActivity(
        { id: textID, embeds, query, conditions, cache: props.textID }
      ))
    }
  })
)
@providePopulateData({ waitForLoad: true })
class MyWorkDisplay extends React.Component {

  constructor(props) {
    super();
    autobind(this);
    var quizzes = _.select(props.quizzes, (quiz) => { return quiz.completed_at !== null });
    quizzes.forEach((quiz) => props.fetchSingleBookActivity(quiz.text_id))

    this.state = {
    };
  }

  backToShelf(e) {
    $wr.nope(e)
    this.props.switchView({ backToShelf: true });
  }

  loadWork() {

  }

  onWorkDetailsViewChange(detailsViewKey) {
    this.props.switchView({ detailsView: detailsViewKey });
  }

  renderQuizzesView() {
    var quiz = this.props.quiz;

    if (!quiz) {
      return (
        <p className="emptySection">
          The quiz you take on this book goes here. If you're done with
					the book, <a href="#" onClick={this.startQuiz}>do the quiz</a>!
        </p>
      );
    } else if (quiz.draft) {
      return (
        <p className="emptySection">
          Your progress on this quiz is saved. If you're ready to do
					more, <a href="#" onClick={this.startQuiz}>finish the quiz</a>!
        </p>
      );
    } else {
      var quiz;
      if (this.props.visibleScores && !quiz.excluded) {
        var quizScoreDisplay = (
          <ScoreDisplay subjectID={quiz.id} subjectType="Quiz"
            showDenominator mode={ScoreDisplay.CIRCLE_MODE} />
        );
      }

      if (this.props.view == "quizzes" && this.props.visibleScores) {
        var className = "quizzesTopRight";
      }

      var quizCoinsDisplay = (
        <CoinsEarnedDisplay subjectType="Quiz" subjectID={quiz.id} />
      );

      if (CurrentUser.get().prefs.allow_student_writing_deletion) {
        var showRemove = true;
      }

      return (
        <div className="quizContent" >
          <div className={"topRightContainer " + className}>
            {quizScoreDisplay}
            {quizCoinsDisplay}
          </div>
          <QuizDisplay quizID={quiz.id} view={AnswerDisplay.QUIZZES_VIEW}
            viewAsStudent
            enabled={{
              lowerComments: true,
              date: true,
              editControls: showRemove,
              deletion: showRemove,
              startRevision: true,
              cancelRevision: true,
            }} />
        </div>
      );
    }
  }

  render() {
    var toggleOptions = [
      { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER), text: "Quiz" },
      { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.ANSWER), text: "Practice Questions" },
      { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.REVIEW), text: "Reviews" },
      // { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.TEACHERS_PICK), text: "Teacher Picks" },
      { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.QUESTION_BUILDER), text: "Question Builders" }
    ];
    if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
      var exercisesKey = { key: ArbitrarySubjects.asCollection(ArbitrarySubjects.EXERCISE), text: "Exercises" };
      toggleOptions.push(exercisesKey);
    }
    if (this.props.draftCount > 0) {
      var draftToggleText = "Unfinished Work (" + this.props.draftCount + ")";
      toggleOptions.push({ key: ArbitrarySubjects.asCollection(ArbitrarySubjects.DRAFT), text: draftToggleText });
    }
    // show text for current view on dropdown
    var currentDetailViewObj = _.findWhere(toggleOptions, { key: this.props.detailsView })
    if (currentDetailViewObj && currentDetailViewObj.text) {
      var firstOptionText = currentDetailViewObj.text
    } else {
      var firstOptionText = 'Quiz'
    }
    // display dropdown
    var displayToggleOptions = _.map(toggleOptions, (option) => {
      return (
        <ButtonDropdownOption key={ option.text } text={option.text}
          onClick={this.onWorkDetailsViewChange.bind(this, option.key)} />
      )
    })

    var displayToggleOptions = (
      <div className='toggleOptionContainer'>
        <ButtonDropdown text={firstOptionText} dropdownDisplay="link" className="hideOnPrint smallObject">
          {displayToggleOptions}
        </ButtonDropdown>
      </div>
    );
    // var displayToggleOptions = (
    //   <div className="hideOnPrint">
    //     <DisplayToggleControl options={toggleOptions} className="subToggle"
    //       onChange={this.onWorkDetailsViewChange}
    //       activeOptionKey={this.props.detailsView}
    //     />
    //   </div>
    // );
    return (
      <div className="clearfix">

        <div className="hideOnPrint myWork">
          <div className="sidebarWrap">

            <div className="backLink">
              <a href="#" onClick={this.backToShelf}>
                <Glyphicon icon="chevron-left" /> Back
              </a>
            </div>
          </div>

          <div className="detailsWrap">
            {displayToggleOptions}
            <ExpandedWorkDetails view={this.props.detailsView} />
          </div>
        </div>
      </div>
    )
  }
}

MyWorkDisplay.WrappedComponent.propTypes = StrictPropTypes({
  // From component above
  quizzes: PropTypes.func,
  populateData: PropTypes.func,
  fetchQuizzes: PropTypes.func,
  fetchQuestions: PropTypes.func,
  fetchAnswers: PropTypes.func,
  fetchActivities: PropTypes.func,
  fetchTasks: PropTypes.func,
  fetchResponses: PropTypes.func,
  fetchSingleBookActivity: PropTypes.func,

  userID: PropTypes.number,
  draftCount: PropTypes.number,
  reviews: PropTypes.array,
  reviews: PropTypes.array,
  responses: PropTypes.array,
  answers: PropTypes.array,
  quizzes: PropTypes.array,
  activities: PropTypes.array,
  tasks: PropTypes.array,
  questionBuilders: PropTypes.array,

  detailsView: PropTypes.string,
  switchView: PropTypes.func.isRequired,

  // @connect handler
  populateData: PropTypes.func,
});

module.exports = MyWorkDisplay;


// WEBPACK FOOTER //
// ./modules/components/reading/shelves/MyWorkDisplay.js